var map = {
	"./app-accept-and-enrol.png": 10578,
	"./background-gradient-black.png": 25218,
	"./background-gradient-white.png": 76638,
	"./company_logos.png": 37928,
	"./cover-2-lg.png": 21926,
	"./email.png": 33005,
	"./facebook.png": 48900,
	"./fonts/metropolis-bold-webfont.woff": 42176,
	"./fonts/metropolis-medium-webfont.woff": 45350,
	"./fonts/metropolis-regular-webfont.woff": 15196,
	"./fonts/metropolis-semibold-webfont.woff": 22115,
	"./fonts/semplicitapro-bold-webfont.woff": 12298,
	"./fonts/semplicitapro-webfont.woff": 49996,
	"./fourth-logo-new.png": 98851,
	"./fourth-logo-old.png": 75730,
	"./fourth-logo.png": 30939,
	"./google-play-badge.png": 2249,
	"./icons/Alarm": 56855,
	"./icons/Alarm.vue": 56855,
	"./icons/AlarmFilled": 98454,
	"./icons/AlarmFilled.vue": 98454,
	"./icons/ArrowDown": 79805,
	"./icons/ArrowDown.vue": 79805,
	"./icons/ArrowLeft": 71206,
	"./icons/ArrowLeft.vue": 71206,
	"./icons/ArrowRight": 37160,
	"./icons/ArrowRight.vue": 37160,
	"./icons/ArrowUp": 25258,
	"./icons/ArrowUp.vue": 25258,
	"./icons/Calendar": 40136,
	"./icons/Calendar.vue": 40136,
	"./icons/CaretDown": 16775,
	"./icons/CaretDown.vue": 16775,
	"./icons/CaretLeft": 65704,
	"./icons/CaretLeft.vue": 65704,
	"./icons/CaretRight": 72592,
	"./icons/CaretRight.vue": 72592,
	"./icons/CaretUp": 9632,
	"./icons/CaretUp.vue": 9632,
	"./icons/ChartLineUp": 13039,
	"./icons/ChartLineUp.vue": 13039,
	"./icons/ChatsCircle": 79575,
	"./icons/ChatsCircle.vue": 79575,
	"./icons/CheckBold": 12945,
	"./icons/CheckBold.vue": 12945,
	"./icons/CheckCircle": 42915,
	"./icons/CheckCircle.vue": 42915,
	"./icons/CheckCircleFilled": 69034,
	"./icons/CheckCircleFilled.vue": 69034,
	"./icons/ChefHat": 68800,
	"./icons/ChefHat.vue": 68800,
	"./icons/Clock": 60601,
	"./icons/Clock.vue": 60601,
	"./icons/Copy": 5440,
	"./icons/Copy.vue": 5440,
	"./icons/Cross": 13485,
	"./icons/Cross.vue": 13485,
	"./icons/Download": 23226,
	"./icons/Download.vue": 23226,
	"./icons/Edit": 47253,
	"./icons/Edit.vue": 47253,
	"./icons/Envelope": 28351,
	"./icons/Envelope.vue": 28351,
	"./icons/File": 95622,
	"./icons/File.vue": 95622,
	"./icons/FileUser": 66753,
	"./icons/FileUser.vue": 66753,
	"./icons/Info": 51658,
	"./icons/Info.vue": 51658,
	"./icons/Link": 20751,
	"./icons/Link.vue": 20751,
	"./icons/Lock": 64347,
	"./icons/Lock.vue": 64347,
	"./icons/LockOpen": 19990,
	"./icons/LockOpen.vue": 19990,
	"./icons/Logout": 5373,
	"./icons/Logout.vue": 5373,
	"./icons/MapPin": 5341,
	"./icons/MapPin.vue": 5341,
	"./icons/MinusCircle": 75325,
	"./icons/MinusCircle.vue": 75325,
	"./icons/Newspaper": 78184,
	"./icons/Newspaper.vue": 78184,
	"./icons/Padlock": 29005,
	"./icons/Padlock.vue": 29005,
	"./icons/Phone": 26566,
	"./icons/Phone.vue": 26566,
	"./icons/Plus": 81731,
	"./icons/Plus.vue": 81731,
	"./icons/PlusCircle": 61650,
	"./icons/PlusCircle.vue": 61650,
	"./icons/PlusCircleFilled": 28867,
	"./icons/PlusCircleFilled.vue": 28867,
	"./icons/Pound": 52004,
	"./icons/Pound.vue": 52004,
	"./icons/QuestionMark": 96024,
	"./icons/QuestionMark.vue": 96024,
	"./icons/Refresh": 81404,
	"./icons/Refresh.vue": 81404,
	"./icons/Rows": 75770,
	"./icons/Rows.vue": 75770,
	"./icons/Settings": 38228,
	"./icons/Settings.vue": 38228,
	"./icons/Smiley": 17001,
	"./icons/Smiley.vue": 17001,
	"./icons/Star": 22352,
	"./icons/Star.vue": 22352,
	"./icons/StarFilled": 57938,
	"./icons/StarFilled.vue": 57938,
	"./icons/Stars": 71927,
	"./icons/Stars.vue": 71927,
	"./icons/ThumbsDown": 13793,
	"./icons/ThumbsDown.vue": 13793,
	"./icons/ThumbsUp": 90219,
	"./icons/ThumbsUp.vue": 90219,
	"./icons/TickCircle": 10944,
	"./icons/TickCircle.vue": 10944,
	"./icons/Trash": 72862,
	"./icons/Trash.vue": 72862,
	"./icons/User": 96535,
	"./icons/User.vue": 96535,
	"./icons/UserCircle": 64586,
	"./icons/UserCircle.vue": 64586,
	"./icons/UserFilled": 62939,
	"./icons/UserFilled.vue": 62939,
	"./icons/Users": 22882,
	"./icons/Users.vue": 22882,
	"./icons/VerifiedWagestream": 94276,
	"./icons/VerifiedWagestream.vue": 94276,
	"./icons/WarningTriangle": 68145,
	"./icons/WarningTriangle.vue": 68145,
	"./icons/WarningTriangleFilled": 79408,
	"./icons/WarningTriangleFilled.vue": 79408,
	"./icons/rows.svg": 72058,
	"./icons/star.svg": 3740,
	"./ios-badge.png": 36164,
	"./linkedin.png": 21654,
	"./login-phone.png": 75436,
	"./login-social-proof.png": 12294,
	"./login-tablet.png": 93500,
	"./login-wallpaper.png": 88569,
	"./logo-gocardless.jpg": 41612,
	"./logo-small.svg": 36934,
	"./logo-white-small.svg": 98963,
	"./logo-white.svg": 48789,
	"./logo.svg": 69574,
	"./osv-icon.png": 9182,
	"./osv-logo-200.png": 11392,
	"./powered-by-wagestream-white.svg": 15916,
	"./qr-download.png": 86170,
	"./recognition-jigsaw-pieces.png": 56257,
	"./referrals-app-image.png": 84582,
	"./register-background.png": 26092,
	"./registration-locked.png": 43278,
	"./sme-demo-bank-transfer.png": 32807,
	"./sme-demo-track.png": 53913,
	"./stream-symbol-purple.png": 51767,
	"./themes/mhritrent/login-tablet.png": 78643,
	"./themes/mhritrent/logo-small.svg": 2203,
	"./themes/mhritrent/logo-white-small.svg": 20995,
	"./themes/mhritrent/logo-white.svg": 91819,
	"./themes/mhritrent/logo.svg": 61265,
	"./themes/mhrpeoplefirst/login-tablet.png": 10556,
	"./themes/mhrpeoplefirst/logo-small.svg": 64939,
	"./themes/mhrpeoplefirst/logo-white-small.svg": 40347,
	"./themes/mhrpeoplefirst/logo-white.svg": 13578,
	"./themes/mhrpeoplefirst/logo.svg": 24703,
	"./themes/wagestreamus/login-tablet.png": 9931,
	"./themes/wagestreamus/logo-small.svg": 36184,
	"./themes/wagestreamus/logo-white-small.svg": 9889,
	"./themes/wagestreamus/logo-white.svg": 14845,
	"./themes/wagestreamus/logo.svg": 47305,
	"./themes/zellis/login-tablet.png": 28657,
	"./themes/zellis/logo-small.svg": 13061,
	"./themes/zellis/logo-white-small.svg": 5391,
	"./themes/zellis/logo-white.svg": 79462,
	"./themes/zellis/logo.svg": 92375,
	"./user-avatar.png": 10211,
	"./whatsapp.png": 56656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;